<!--
新闻详情页
-->
<template>
  <div :class="$style.detail">
    <div id="js-detail-content" :class="$style.content">
      <div :class="$style.title">
        <h1>{{ data.title }}</h1>
        <p>{{ data.date }}</p>
      </div>
      <div :class="$style.article" v-html="data.text" />
    </div>
    <the-detail-page
      id="js-detail-page"
      :prev="data.prev"
      :next="data.next"
      :class="$style.page"
    />
  </div>
</template>

<script>
import TheDetailPage from './TheDetailPage'

export default {
  components: { TheDetailPage },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return { pinScene: null }
  },
  mounted() {
    this.$nextTick(() => {
      /**
       * Add pin scene
       */
      this.pinScene = this.$scrollmagic
        .scene({
          triggerElement: '#js-detail-content',
          triggerHook: 0,
          duration: this.getDuration(),
        })
        .setPin('#js-detail-page', { pushFollowers: false })

      // indicator
      process.env.NODE_ENV === 'development' &&
        this.pinScene.addIndicators({ name: 'detail pin' })

      this.$scrollmagic.addScene(this.pinScene)

      // 当窗口尺寸发生变化时重置 pin
      window.addEventListener('resize', this.resetPinScene)
    })
  },
  destroyed() {
    /**
     * Destroy pin scene
     */
    this.pinScene && this.pinScene.destroy(true)
    window.removeEventListener('resize', this.resetPinScene)
  },
  methods: {
    // 动态获取 scene duration
    getDuration() {
      return (
        document.getElementById('js-detail-content').clientHeight -
        document.getElementById('js-detail-page').clientHeight -
        150
      )
    },
    // 重置 pin scene
    resetPinScene() {
      if (this.pinScene) {
        this.pinScene.removePin(true)
        this.pinScene.duration(this.getDuration())
        this.pinScene.setPin('#js-detail-page', { pushFollowers: false })
      }
    },
  },
}
</script>

<style lang="less" module>
@content-width: 11.77rem;
@content-padding-left: 3.6rem;
@content-laptop: 0.6; // content 宽度增加  60px
@content-tablet: 2.5; // content 宽度增加 250px

.detail {
  position: relative;
  background-color: #f1f1f1;
}

.content {
  width: @content-width;
  min-height: 9rem;
  padding: @padding-base-title 0.5rem @padding-base-title @content-padding-left;
  background-color: #fff;
  box-sizing: border-box;
}

.title {
  margin-bottom: @padding-title-bot;
  padding: 0.3rem 0;
  border-width: 0.01rem 0;
  border-style: solid;
  border-color: #e0e0e0;

  h1 {
    font-weight: 400;
    font-size: 18px;
    line-height: 1.5;
  }

  p {
    display: flex;
    align-items: center;
    margin-top: 1em;
    color: #494949;

    &::before {
      .size(16px);
      content: '';
      display: block;
      margin-right: 0.5em;
      background: url('./images/detail-clock.png') no-repeat;
      background-size: 100% 100%;
    }
  }
}

.article {
  line-height: 2;

  a {
    color: @primary;
    text-decoration: underline;
  }

  img {
    max-width: 100%;
    height: auto !important;
  }
}

.page {
  position: absolute;
  top: @padding-base-title;
  left: @content-width;
}

// 各尺寸模式下宽度适应性调整
@media screen and (max-width: @laptop-width) {
  .content {
    width: @content-width + @content-laptop;
    padding-left: @content-padding-left - @content-laptop;
  }

  .page {
    left: @content-width + @content-laptop;
  }
}

@media screen and (max-width: @tablet-width) {
  .content {
    width: @content-width + @content-tablet;
    padding-left: @content-padding-left - @content-tablet;
  }

  .page {
    left: @content-width + @content-tablet;
  }
}

@media screen and (max-width: @mini-width) {
  .detail {
    background-color: #fff;
  }

  .content {
    width: auto;
    padding-right: @content-padding-left - @content-tablet;
  }

  .page {
    padding: 1.5em 0 2em;
    border-top: 1px solid #eee;
  }
}

// mini 尺寸下重置 pin
@media screen and (max-width: @mini-width) {
  .detail {
    :global(.scrollmagic-pin-spacer) {
      inset: 0 !important;
      margin: 0 !important;
      width: auto !important;
      min-width: none !important;
      height: auto !important;
      min-height: none !important;
    }
  }

  .page {
    position: static !important;
    width: auto !important;
    margin: 0 @content-padding-left - @content-tablet !important;
    inset: 0 !important;
  }
}
</style>
